export const QueueMediaTypes = [
    'Email',
    'Voice',
    'Webchat',
    'Socials',
    'Mixed',
    'Multiple',
    'Unknown',
] as const;

export type QueueMediaType = (typeof QueueMediaTypes)[number];
